import { createApi } from '@reduxjs/toolkit/query/react';
import checkStatus from '../../../../shared/http/checkStatus';
import HttpMethods from '../../../../shared/api/HttpMethods';
import reducerPath from '../../../../app/reducerPath';
import config from '../../../../shared/api/config';
// eslint-disable-next-line boundaries/element-types
import baseQueryWithReAuth from '../../../baseQueryWithReAuth/baseQueryWithReAuth';
// eslint-disable-next-line import/no-named-as-default
import geoZoneFromDtoService from '../services/data/geoZone-from-dto.service';
import createHeadRequest from '../../../../shared/http/createHeadRequest';

// Описываем методы обращения к беку
export const geoZoneApi = createApi({
  reducerPath: `${reducerPath.geoZone}/api`,
  baseQuery: (...arg) => baseQueryWithReAuth(...arg, `${config.baseUrl}/geo-zones/`),
  endpoints: (builder) => ({
    postGeoZonesImport: builder.mutation({
      query: (body) => ({
        ...createHeadRequest({
          customHeader: {
            url: `/import`,
            method: HttpMethods.POST,
          },
        }),
        validateStatus: checkStatus,
        body,
      }),
      transformResponse: geoZoneFromDtoService,
    }),
    getGeoZonesExport: builder.query({
      query: () => ({
        url: `/export`,
        method: HttpMethods.GET,
        validateStatus: checkStatus,
      }),
      transformResponse: geoZoneFromDtoService,
    }),

    getGeoZones: builder.query({
      query: ({ params } = {}) => ({
        url: `/`,
        method: HttpMethods.GET,
        params,
        validateStatus: checkStatus,
      }),
      transformResponse: geoZoneFromDtoService,
    }),

    findGeoZoneByCoords: builder.query({
      query: ({ lat, lon }) => ({
        url: `find`,
        method: HttpMethods.GET,
        params: { lat, lon },
        validateStatus: checkStatus,
      }),
      transformResponse: geoZoneFromDtoService,
    }),
  }),
});

export const {
  useLazyGetGeoZonesExportQuery,
  usePostGeoZonesImportMutation,
  useGetGeoZonesQuery,
  useLazyGetGeoZonesQuery,
  useLazyFindGeoZoneByCoordsQuery,
} = geoZoneApi;
